/**
 * @param property a CSS property like padding, margin, fontSize, etc.
 * @returns Theme scale for the given CSS property
 */
export function cssPropertyThemeKey(property) {
    switch (property) {
        case 'padding':
        case 'paddingTop':
        case 'paddingRight':
        case 'paddingBottom':
        case 'paddingLeft':
        case 'margin':
        case 'marginTop':
        case 'marginRight':
        case 'marginBottom':
        case 'marginLeft':
        case 'gap':
            return 'spacing';
        case 'fontSize':
            return 'fontSize';
        case 'fontWeight':
            return 'fontWeight';
        case 'fontStyle':
            return 'fontStyle';
        case 'lineHeight':
            return 'lineHeight';
        case 'color':
            return 'colors';
        case 'borderRadius':
            return 'borderRadius';
        case 'background':
        case 'backgroundColor':
            return 'colors';
        default:
            return undefined;
    }
}
